import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
    ModalWithStyles,
    ModalInnerContainer,
    BodyContainer,
    InputOuterContainer,
    InputContainer,
    AccountInput,
    InnerBottomContainer,
    ModalFooterContainer,
    SubtitleP,
} from 'components/organisms/SignUp/SignUpComponents';
import { emailRegex } from 'utils/constants';
import { Body1, Body3, H4 } from 'ensightful-koala-ui';

const ResetButtonDiv = styled.div`
    display: flex;
    border-radius: 6px;
    align-items: center;
    justify-content: center;
    width: 130px;
    height: 40px;
    color: white;
    letter-spacing: 1.25px;
    background-color: ${(props) => (props.haveChange ? '#6347FF' : '#D3CCFF')};
    text-align: center;
    font-size: 14px;

    &:hover {
        background-color: ${(props) => (props.haveChange ? '#7f68ff' : '#D3CCFF')};
        cursor: pointer;
    }
`;

const CancelButton = styled(Body3)`
    &:hover {
        cursor: pointer;
    }
`;

const ForgotPassword = ({ visible, callback, email, goBack }) => {
    const [form, setForm] = useState({ email });
    const [errors, setErrors] = useState({ email: '' });

    const getErrorMessage = (key, value) => {
        value = value?.trim();
        switch (key) {
            case 'email':
                return value && emailRegex.test(value) ? '' : 'Please enter a valid email.';
            default:
                return '';
        }
    };

    const validate = (key, value) => {
        const errorMessage = getErrorMessage(key, value);
        setErrors((errors) => {
            return {
                ...errors,
                [key]: errorMessage,
            };
        });
    };

    const validateAll = () => {
        return !Boolean(
            Object.keys(errors)
                .map((key) => {
                    validate(key, form[key]);
                    return getErrorMessage(key, form[key]);
                })
                .reduce((cur, acc) => {
                    return cur + acc;
                }, '')
        );
    };

    const handleChange = (key, value) => {
        setForm((form) => {
            return {
                ...form,
                [key]: value,
            };
        });
        if (Object.keys(errors).includes(key)) {
            if (errors[key]) validate(key, value);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key !== 'Enter') return;
        if (!validateAll()) return;
        return callback({
            source: 'codeVerificatoinModal',
            data: {
                ...form,
                name: `${form.firstName} ${form.lastName}`.trim(),
            },
        });
    };

    const handleCallback = () => {
        if (!validateAll()) return;
        return callback({
            source: 'codeVerificatoinModal',
            data: {
                ...form,
                name: `${form.firstName} ${form.lastName}`.trim(),
            },
        });
    };

    const isValid = !Boolean(Object.values(errors).reduce((cur, acc) => cur + acc, ''));

    useEffect(() => {
        if (email?.length > 0) {
            setForm((prev) => {
                return { ...prev, email };
            });
        }
    }, [email]);

    return (
        <ModalWithStyles
            closable={false}
            centered
            mask={false}
            visible={visible}
            destroyOnClose
            maskClosable
            width={440}
            footer={null}
            style={{ position: 'relative' }}
        >
            <ModalInnerContainer>
                <H4>Forgot Password</H4>
                <Body1 style={{ textAlign: 'center' }}>
                    Please enter the email you signed up so we may send you a link to reset your password.
                </Body1>
                <BodyContainer>
                    <InnerBottomContainer>
                        <InputOuterContainer>
                            <SubtitleP>Email</SubtitleP>
                            <InputContainer>
                                <AccountInput
                                    type={'email'}
                                    value={form.email}
                                    onChange={(e) => handleChange('email', e.target.value)}
                                    onBlur={(e) => validate('email', e.target.value)}
                                    onKeyDown={handleKeyDown}
                                />
                            </InputContainer>
                            <div>
                                <span
                                    style={{
                                        visibility: errors.email ? 'visible' : 'hidden',
                                        color: '#DB5019',
                                    }}
                                >
                                    • {errors.email}
                                </span>
                            </div>
                        </InputOuterContainer>
                    </InnerBottomContainer>
                </BodyContainer>
            </ModalInnerContainer>
            <ModalFooterContainer style={{ marginBottom: 24, padding: 0 }}>
                <ResetButtonDiv haveChange={isValid} onClick={handleCallback}>
                    Reset Password
                </ResetButtonDiv>
            </ModalFooterContainer>
            <CancelButton style={{ color: '#616161', textAlign: 'center' }} onClick={goBack}>
                Cancel
            </CancelButton>
        </ModalWithStyles>
    );
};

export default ForgotPassword;
